/* import __COLOCATED_TEMPLATE__ from './flash-portal.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({});